import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';

let IconLock = require('../img/ic_lock.svg');
const Wrapper = styled.div`
  position: relative;
  text-align: center;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: -5px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  text-align: center;
  z-index: 1;
  background-color: white;
  padding-top: 11px;
`;

export default class extends Component {
  state = {hovered: false};

  render() {
    const {
      props: {locked, toggleLock},
      state: {hovered},
    } = this;
    const buttonVisible = !locked || hovered;
    return (
      <Wrapper onMouseEnter={() => this.setState({hovered: true})} onMouseLeave={() => this.setState({hovered: false})}>
        <span style={{visibility: buttonVisible ? 'visible' : 'hidden'}}>
          <FlatButton onClick={() => toggleLock(!locked)} label={locked ? 'Gerät entsperren' : 'Gerät sperren'} />
        </span>
        <IconWrapper style={{visibility: buttonVisible ? 'hidden' : 'visible'}}>
          <img src={IconLock} alt={`Gerät ${locked ? '' : 'nicht'} gesperrt`} width={15} />
        </IconWrapper>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LockToggle.js